import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '@app/store/app.reducer';
import { Observable } from 'rxjs';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';

@Injectable({
    providedIn: 'root'
})
export class UploadFormService {
    public lastUpload$: Observable<any> = this.store.pipe(select(fromMyClaims.getLastUpload));
    public isLoading$: Observable<any> = this.store.pipe(select(fromMyClaims.isDocumentsLoading));
    constructor(private store: Store<fromRoot.State>) { }
}
